import { render, staticRenderFns } from "./PlanFeatures.vue?vue&type=template&id=98066c18&"
import script from "./PlanFeatures.vue?vue&type=script&lang=js&"
export * from "./PlanFeatures.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports